<template>
  <div id="media-page">
    <div class="row mb-4" style="margin-top: 15px">
      <div class="col-12 px-gap">
        <div
          class="bg-white p-t-5 p-b-5 d-flex align-items-center p-l-15 p-r-15 rounded shade"
        >
          <!-- title -->
          <h3 style="font-size: 20px">
            <i class="bi bi-card-checklist"></i>
            Blacklist dan Whitelist Media
            <i
              class="bi bi-question-circle text-blue"
              v-tooltip.right="{ ref: 'groupHelper' }"
            ></i>
          </h3>
          <!-- tooltip helper -->
          <div ref="groupHelper" class="tooltip-content">
            <div>
              <b>Blacklist Media</b> digunakan untuk menandai media yang tidak
              diperlukan.
            </div>
            <div>
              <b>Whitelist Media</b> digunakan untuk menandai media yang
              diperlukan.
            </div>
          </div>
          <!-- toggle blacklist & whitelist -->
          <div
            class="form-check switch switch-lg complete right d-flex m-b-0 ml-auto"
          >
            <span> BLACKLIST </span>
            <input
              type="checkbox"
              id="media-toggle"
              v-model="is_whitelist"
              @click="handleToggleClick"
            />
            <label for="media-toggle"></label>
            <span class="ml-2"> WHITELIST </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12 px-gap">
        <div class="bg-white p-3 rounded shade">
          <div class="row">
            <!-- blacklist title -->
            <div class="col-md-8 component-header component-header-left">
              <h6>Daftar Blacklist Media</h6>
            </div>
            <!-- add blacklist media button -->
            <div class="col-md-4 component-header component-header-right">
              <button
                :disabled="temp_is_whitelist"
                aria-label=""
                v-on:click="addBlacklist"
                class="btn btn-success btn-icon-left"
                type="button"
              >
                <i class="bi bi-plus"></i>
                <span class="">Tambah Blacklist</span>
              </button>
            </div>
          </div>
          <!-- blacklist table -->
          <table class="table table-bordered" id="blacklist_table">
            <thead>
              <tr>
                <th>Nama Media</th>
                <th width="20%">Jenis Media</th>
                <th width="25%">Tanggal Input</th>
                <th class="text-center">Aksi</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 px-gap">
        <div class="bg-white p-3 rounded shade">
          <div class="row">
            <!-- whitelist title -->
            <div class="col-md-8 component-header component-header-left">
              <h6>Daftar Whitelist Media</h6>
            </div>
            <!-- add whitelist button -->
            <div class="col-md-4 component-header component-header-right">
              <button
                :disabled="!temp_is_whitelist"
                aria-label=""
                v-on:click="addWhitelist"
                class="btn btn-success btn-icon-left"
                type="button"
              >
                <i class="bi bi-plus"></i>
                <span class="">Tambah Whitelist</span>
              </button>
            </div>
          </div>
          <!-- whitelist button -->
          <table class="table table-bordered" id="whitelist_table">
            <thead>
              <tr>
                <th>Nama Media</th>
                <th width="20%">Jenis Media</th>
                <th width="25%">Tanggal Input</th>
                <th class="text-center">Aksi</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- dynamic modal component -->
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="modal_data"
      :static="true"
    />
  </div>
</template>
  
<script>
import $ from "jquery";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_media from "@/views/components/settings/media/modal_add_media.vue";
import modal_edit_media from "@/views/components/settings/media/modal_edit_media.vue";
import moment from "moment";
import swal from "sweetalert";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

var whitelist_modal = {
  title: "Tambah Whitelist Media",
  subtitle: "Silahkan masukan Whitelist Media baru yang akan ditambahkan",
  tipe: "whitelist",
  component: modal_add_media,
};
var blacklist_modal = {
  title: "Tambah Blacklist Media",
  subtitle: "Silahkan masukan Blacklist Media baru yang akan ditambahkan",
  tipe: "blacklist",
  component: modal_add_media,
};
var edit_whitelist_modal = {
  title: "Edit Whitelist Media",
  subtitle: "Silahkan masukan Whitelist Media yang akan diubah",
  tipe: "whitelist",
  item: null,
  component: modal_edit_media,
};
var edit_blacklist_modal = {
  title: "Edit Blacklist Media",
  subtitle: "Silahkan masukan Blacklist Media yang akan diubah",
  tipe: "blacklist",
  item: null,
  component: modal_edit_media,
};

export default {
  name: "Media",
  title: "Settings Media | Online Media Monitoring",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      is_whitelist: false,
      temp_is_whitelist: false,
      currentModal: null,
      modal_key: 0,
      table_whitelist: null,
      table_blacklist: null,
      modal_data: null,
      whitelist: null,
      blacklist: null,
    };
  },
  methods: {
    handleToggleClick: function () {
      const media = this.is_whitelist ? "Blacklist" : "Whitelist";
      const temp_media = this.temp_is_whitelist ? "Whitelist" : "Blacklist";
      swal({
        title: "Apakah anda yakin?",
        text: `Dengan mengubah menjadi ${media} akan menghapus semua ${temp_media} media`,
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          this.temp_is_whitelist = this.is_whitelist;
          this.changeToggle();
        } else {
          this.is_whitelist = this.temp_is_whitelist;
        }
      });
    },
    setStatusMedia: function () {
      const is_whitelist =
        this.$store.getters.user.project.project_detail.is_whitelist;
      if (is_whitelist) {
        this.is_whitelist = true;
        this.temp_is_whitelist = true;
        this.getWhitelist();
      } else {
        this.is_whitelist = false;
        this.temp_is_whitelist = false;
        this.getBlacklist();
      }
    },
    changeToggle: function () {
      let api =
        process.env.VUE_APP_API_URL +
        "project-status/blacklist-whitelist/" +
        this.id_project;
      this.$http
        .put(api, {
          is_whitelist: this.is_whitelist == true ? 1 : 0,
        })
        .then(() => {
          this.temp_is_whitelist = this.is_whitelist;
          this.getProjectDetail();
          this.getWhitelist();
          this.getBlacklist();
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Perubahan media berhasil dilakukan.',
              position: "top",
              timeout: 5000,
              type: "success",
            })
            .show();
        })
        .catch(() => {
          this.is_whitelist = this.temp_is_whitelist;
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah media',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    getProjectDetail: function () {
      let api =
        process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.$store.dispatch("user_project", response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    dateFormatter: function (date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    addWhitelist: function () {
      this.modal_key++;
      this.currentModal = whitelist_modal;
    },
    addBlacklist: function () {
      this.modal_key++;
      this.currentModal = blacklist_modal;
    },
    getWhitelist: function () {
      let api =
        process.env.VUE_APP_API_URL +
        `blacklist-whitelist-media/${this.id_project}?tipe=whitelist&page=1&items=10000`;
      this.$http.get(api).then((res) => {
        if (res.data.whitelist_media.length > 0) {
          this.whitelist = res.data.whitelist_media;
          this.assembleWhitelistTable();
        } else {
          this.whitelist = [];
          this.table_whitelist.clear();
          this.table_whitelist.draw(false);
        }
      });
    },
    getBlacklist: function () {
      let api =
        process.env.VUE_APP_API_URL +
        `blacklist-whitelist-media/${this.id_project}?tipe=blacklist&page=1&items=10000`;
      this.$http.get(api).then((res) => {
        if (res.data.blacklist_media.length > 0) {
          this.blacklist = res.data.blacklist_media;
          this.assembleBlacklistTable();
        } else {
          this.blacklist = [];
          this.table_blacklist.clear();
          this.table_blacklist.draw(false);
        }
      });
    },
    assembleWhitelistTable: function () {
      let btn;
      this.table_whitelist.clear();
      for (let index in this.whitelist) {
        btn =
          '<center><button class="btn btn-sm btn-complete m-r-5 ch"><i class="bi bi-pencil-square"></i></button><button class="btn btn-sm btn-danger del"><i class="bi bi-trash"></i></button></center>';
        this.table_whitelist.row
          .add([
            this.whitelist[index].nama_media,
            this.whitelist[index].source == "news"
              ? "Online News"
              : this.whitelist[index].source == "media_cetak"
              ? "Media Cetak"
              : "Media TV",
            this.dateFormatter(this.whitelist[index].created_at.$date),
            btn,
          ])
          .node().id = this.whitelist[index]._id.$oid;
        this.table_whitelist.draw(false);
      }
    },
    assembleBlacklistTable: function () {
      let btn;
      this.table_blacklist.clear();
      for (let index in this.blacklist) {
        btn =
          '<center><button class="btn btn-sm btn-complete m-r-5 ch"><i class="bi bi-pencil-square ch"></i></button><button class="btn btn-sm btn-danger del"><i class="bi bi-trash"></i></button></center>';
        this.table_blacklist.row
          .add([
            this.blacklist[index].nama_media,
            this.blacklist[index].source == "news"
              ? "Online News"
              : this.blacklist[index].source == "media_cetak"
              ? "Media Cetak"
              : "Media TV",
            this.dateFormatter(this.blacklist[index].created_at.$date),
            btn,
          ])
          .node().id = this.blacklist[index]._id.$oid;
        this.table_blacklist.draw(false);
      }
    },
    deleteMedia: function (tipe, id) {
      const tp = tipe.toLowerCase();
      swal({
        title: "Apakah anda yakin?",
        text: `Akan menghapus ${tp} media tersebut.`,
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          const api =
            process.env.VUE_APP_API_URL +
            "blacklist-whitelist-media/delete/" +
            id;
          this.$http.delete(api).then((res) => {
            if (res.status == 200) {
              $("body")
                .pgNotification({
                  style: "bar",
                  message: `<i class="bi bi-check-circle"></i> <b>Berhasil!</b> ${tipe} media berhasil dihapus!`,
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
              if (tipe == "Whitelist") {
                this.getWhitelist();
              } else {
                this.getBlacklist();
              }
            } else {
              $("body")
                .pgNotification({
                  style: "bar",
                  message: `<i class="bi bi-check-circle"></i> <b>Gagal!</b> Terjadi kesalahan saat menghapus ${tipe} media.`,
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            }
          });
        }
      });
    },
    editMedia: function (tipe, id) {
      this.modal_key++;
      if (tipe == "Whitelist") {
        this.currentModal = edit_whitelist_modal;
        const selected = this.whitelist.find((el) => el._id.$oid == id);
        this.currentModal.item = selected;
      } else {
        this.currentModal = edit_blacklist_modal;
        const selected = this.blacklist.find((el) => el._id.$oid == id);
        this.currentModal.item = selected;
      }
    },
  },
  created: function () {
    this.setStatusMedia();
  },
  mounted: function () {
    this.table_whitelist = $("#whitelist_table").DataTable({
      columnDefs: [
        {
          targets: 3,
          orderable: false,
        },
      ],
      order: [[1, "asc"]],
    });
    this.table_blacklist = $("#blacklist_table").DataTable({
      columnDefs: [
        {
          targets: 3,
          orderable: false,
        },
      ],
      order: [[1, "asc"]],
    });
    let self = this;
    $("#whitelist_table tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.deleteMedia("Whitelist", id);
    });
    $("#blacklist_table tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.deleteMedia("Blacklist", id);
    });
    $("#whitelist_table tbody").on("click", ".ch", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.editMedia("Whitelist", id);
    });
    $("#blacklist_table tbody").on("click", ".ch", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.editMedia("Blacklist", id);
    });
  },
};
</script>